class ReportFrameViewController {
  constructor(
    $scope,
    rx,
    CurrentFilterService
  ) {
    const subscriptions = [
      $scope.$toObservable('$ctrl.filterData')
      .switchMap(({
        newValue
      }) => {
        if (!newValue) {
          return rx.Observable.empty();
        }
        return rx.Observable.of(this.filterData.loading)
          .concat(newValue.loading$);
      })
      .do((loading) => {
        this.src = CurrentFilterService.getReportUrl(this.filterData.filter);
        if (loading) {
          this.frameLoad = this.filterData.frameLoad;
          // this.src = CurrentFilterService.getReportUrl(this.filterData.filter);
        }
      })
      .subscribe(() => {}),
    ];
    $scope.$on('$destroy', () => {
      subscriptions.forEach((s) => s.dispose());
    });
  }

  onFrameCreate(frame) {
    frame.scClickToUse = this.clickToUse;
  }

  onFrameLoad(frame) {
    if (this.frameLoad === this.filterData.frameLoad) {
      this.filterData.frameLoad.resolve(null);
    }
  }
}

export const ReportFrameViewComponent = {
  template: require('./report-frame-view.component.html'),
  bindings: {
    filterData: '<',
    maximize: '<',
    minHeight: '<?',
    clickToUse: '<?',
  },
  controller: ReportFrameViewController,
};



// WEBPACK FOOTER //
// ./src/view/report-frame-view.component.js